import script from "./ConfirmEmailAddress.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmEmailAddress.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import ConvertToNewEmail from "@/components/ConvertToNewEmail.vue";
import SignupMainContainer from "@/components/signup/SignupMainContainer.vue";
script.components = Object.assign({}, { ConvertToNewEmail, SignupMainContainer }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { ConvertToNewEmail, SignupMainContainer }, script.__o.components);}